import React from "react";
import Star from "./star.svg";

function SunStarIcon() {
  return <img src={Star} alt="Star Icon" />;
}

export default SunStarIcon;
